export { RadioBadgeComponent } from './radio-badge.component';
